<template>
  <div>
    <div class="w-full h-auto flex justify-center bg-white border-b border-gray-200 shadow-sm">
      <div class="w-full max-w-3xl py-5 px-5 md:px-1">
        <img :src="logoSrc" alt="Logo Atendimento">
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ExternalContainer',
  data () {
    return {
      logoSrc: ''
    }
  },
  created () {
    this.setLogoBasedOnDomain()
  },
  methods: {
    setLogoBasedOnDomain () {
      const currentHost = window.location.hostname
      const tokstokDomain = process.env.VUE_APP_DOMAIN_TOKSTOK
      const supportDomain = process.env.VUE_APP_DOMAIN_SUPPORT

      if (currentHost.includes(tokstokDomain)) {
        this.logoSrc = require('@/assets/logo_tokstok_atendimento.svg')
      } else if (currentHost.includes(supportDomain)) {
        this.logoSrc = require('@/assets/logo_grupotoky_atendimento.svg')
      } else {
        this.logoSrc = require('@/assets/logo_mobly_atendimento.svg')
      }
    }
  }
}
</script>
